import { atom } from 'jotai';
import { Service } from '../types/common';

export const quotationAtom = atom<Service[]>([]);

export const prohibitedHsCodeMapAtom = atom<Record<string, boolean>>({});

export const prohibitedCouriersAtom = atom<string[]>([]);

export default quotationAtom;
